package pl.mothdigital.neuronowi.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.theme.colors.*
import com.varabyte.kobweb.silk.theme.shapes.*
import pl.mothdigital.neuronowi.common.utils.openInstagramNeuronowi
import pl.mothdigital.neuronowi.theme.*

val InstagramButtonStyle = CssStyle.base {
    Modifier.clip(CircleF(radius = 40f))
}

@Composable
fun InstagramButton(
    buttonColorPalette: ColorPalette = SiteTheme.green,
    contentColor: Color = SiteTheme.white._900,
) {
    Button(
        onClick = { openInstagramNeuronowi() },
        modifier = InstagramButtonStyle.toModifier().ariaLabel("Odwiedź naszą stronę na Instagramie"),
        colorPalette = buttonColorPalette,
        content = { FaInstagram(Modifier.color(contentColor)) }
    )
}

